export default __webpack_public_path__ + "imgs/news_default_cover.81785504.jpg";